import { Trans, t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";

const mojoLisaImage = getImageSrc("toolkit/src/pods/conundrums/assets/mojoLisaFull.png");
const mojoLisaMad = getImageSrc("toolkit/src/pods/conundrums/assets/mojoLisaMad.png");
const mojoLisaPaint = getImageSrc("toolkit/src/pods/conundrums/assets/mojoLisaPaint.png");
const mojoLisaVisit = getImageSrc("toolkit/src/pods/conundrums/assets/mojoLisaVisit.png");

export const getTitle = () => t`Mojo Lisa`;
export const getDescription = () => t`Mojo purchased the Mona Lisa, and wants to paint over it!`;
export const getQuestionText = () => t`Is this okay?`;

const activities: Slide[] = [
  IntroSlide(getTitle, getDescription, getQuestionText, mojoLisaImage),
  ExpectationsSlide(),
  DescriptionSlide(
    () =>
      t`The Mona Lisa is 500 years old, and is the most famous painting in the world! Every year, thousands of people travel to Paris to see it.`,
    mojoLisaVisit,
  ),
  DescriptionSlide(
    () => t`Somehow, Mojo bought the Mona Lisa - and he wants to paint over it, to look like himself!`,
    mojoLisaPaint,
  ),
  OptionsSlide(
    () => t`Should Mojo be allowed to paint the Mona Lisa?`,
    [
      { id: "yes", option: () => t`Yes, because...` },
      { id: "no", option: () => t`No, because...` },
    ],
  ),
  DescriptionSlide(() => t`"If I can't alter the painting, I'll just DESTROY it!"`, mojoLisaMad),
  OptionsSlide(
    <div>
      <Trans>
        Should Mojo be allowed to <i>destroy</i> the Mona Lisa?
      </Trans>
    </div>,
    [
      { id: "yes", option: () => t`Yes, because...` },
      { id: "no", option: () => t`No, because...` },
    ],
  ),
  PairShareSlide(
    () =>
      t`Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?`,
  ),
  ShareToStorySlide(
    () => t`Congrats on completing this Conundrum!`,
    () => t`Now that was an interesting question indeed.`,
    "https://static.classdojo.com/img/mojoLisaShare.png",
    () => t`Great discussion!`,
  ),
];

export default activities;
